<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DkbJ8E/tc-custom/9781035815258.jpg?1705766047896" alt="This image is the cover for the book Murder Spells Trouble with a Capital M"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Spells Trouble with a Capital M
      </h1>
      <p class="bookDescription body article font2">
        <p>In a world of technological advancement, political correctness to the point of absurdity and bright vibrant colours. One man dares to live in sepia. Detective Joseph Quincy Kingly is back. And he’s back with inadvertence. When a dastardly murder is committed, Detective Kingly is the only person in the immediate area who can possibly solve the case. Of course, it won’t be that easy for the man who should be everyone’s favourite private eye. This time he must answer to the local police inspector Mary McCaskill, a no-nonsense, by-the-book cop with whom Kingly shares a sordid past. This will the biggest test of Detective Joseph Quincy Kingly’s abilities yet. Can he solve the case without being pulled into a predictable romantic sub-plot? Or is he in well over his hat once again?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rory Joe Heynemann
      </h2>
      
      <p class="authorDescription body article">Rory Joe Heynemann is an infant of the 1980s, child of the 1990s and an adult of the 21st century who should have been born in the 1950s. He was born and raised in Western Australia, where he attended Curtin University studying Creative Writing. In his mid-20s, he moved to the Gold Coast, Queensland, where he resides to this day. At least upon the writing of this bio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21506782